import { CountUp, FadeIn, Disclaimer } from "./common";
import CategoryHeader from "./CategoryHeader";
import { CategoryBackground } from "./SciBackground";
import { TrendingUp, Database, Layers, ArrowRightLeft } from "lucide-react";

const KPIS = [
  {
    icon: TrendingUp,
    value: 45,
    prefix: "~",
    suffix: "%",
    label: "Scrap Reduction",
    note: "CAPA/RCA-driven process improvement",
    professional: true,
  },
  {
    icon: Database,
    value: 100,
    suffix: "K+",
    label: "Manufacturing / Product Quality Records",
    note: "Experience automating and analyzing large operational datasets",
    professional: true,
  },
  {
    icon: Layers,
    value: "Multi-Source",
    label: "Manufacturing Data Integration",
    note: "Analytical files, Product Quality systems, APIs, sensors, manufacturing metadata and Quality records",
    professional: true,
  },
  {
    icon: ArrowRightLeft,
    value: "End-to-End",
    label: "Problem → Data → RCA → Change",
    note: "Connecting technical investigation to Quality-system and process actions",
    professional: true,
  },
];

export default function Impact() {
  return (
    <section className="relative overflow-hidden" data-testid="impact-section">
      <CategoryBackground variant="impact" accent="cyan" accent2="teal" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20">
      <CategoryHeader
        eyebrow="Business Impact"
        title="Measurable outcomes, not activity"
        description="Professional impact from regulated manufacturing work — stated separately from the synthetic demonstration data used in the interactive labs."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
        {KPIS.map((kpi, i) => {
          const Icon = kpi.icon;
          return (
            <FadeIn key={kpi.label} delay={i * 0.08}>
              <div className="panel p-6 h-full hover:border-cyan/40 transition-colors" data-testid={`impact-card-${i}`}>
                <Icon className="w-5 h-5 text-teal mb-4" aria-hidden="true" />
                <p className="text-3xl lg:text-4xl text-cyan font-semibold">
                  <CountUp value={kpi.value} prefix={kpi.prefix || ""} suffix={kpi.suffix || ""} />
                </p>
                <p className="font-sans text-sm font-semibold text-paper mt-3">{kpi.label}</p>
                <p className="text-xs text-steel mt-2 leading-relaxed">{kpi.note}</p>
                <p className="font-mono text-[9px] uppercase tracking-[0.18em] text-teal/70 mt-4">Professional impact</p>
              </div>
            </FadeIn>
          );
        })}
      </div>
      <div className="mt-6 max-w-2xl">
        <Disclaimer>
          The four cards above describe actual professional impact. Interactive dashboards elsewhere on this site use clearly labelled synthetic
          demonstration data — the two are never mixed.
        </Disclaimer>
      </div>
      </div>
    </section>
  );
}
